import DefaultSelect from '@hero/ui-kit/inputs/DefaultSelect';
import Form from '@hero/ui-kit/inputs/Form';
import * as React from 'react';
import { useSearchParams } from 'react-router-dom';
import { noop } from 'ts-essentials';
import * as yup from 'yup';

export const actionsSchema = yup
    .object()
    .shape({
        prospect_type: yup.string().nullable().notRequired()
    })
    .defined();

export type ActionsParams = yup.InferType<typeof actionsSchema>;
// 'RTM' | 'D2C' | 'RTM_DTC' | 'RTM_REELECTION'
const options = [
    {
        label: 'All Types',
        value: 'all'
    },
    {
        label: 'RTM',
        value: 'rtm'
    },
    {
        label: 'D2C',
        value: 'd2c'
    },
    {
        label: 'RTM Reelection',
        value: 'rtm_reelection'
    }
];

const ProspectActionsFilter: React.FC = () => {
    const [searchParams, setSearchParams] = useSearchParams();

    const prospect_type = searchParams.get('prospect_type');

    return (
        <Form
            validationSchema={actionsSchema}
            submitFn={noop}
            defaultValues={{
                prospect_type: prospect_type ? prospect_type : 'all'
            }}
        >
            <DefaultSelect
                styles={{ minWidth: '200px' }}
                name="prospect_type"
                onChange={(e) => {
                    const value = e.currentTarget.value;

                    setSearchParams((prevState) => {
                        if (value === 'all') {
                            prevState.delete('prospect_type');
                        } else {
                            prevState.set('prospect_type', value);
                        }

                        return prevState;
                    });
                }}
                options={options}
            />
        </Form>
    );
};

export default ProspectActionsFilter;
